import React from "react";
import { useSelector } from "react-redux";

import { hasFeatureFlag } from "../../store/selectors";

import { AmazonChatButton } from "./amazon-chat-button";
import { ChatButton8x8 } from "./chat-button-8x8";

export const LiveChatButton = props => {
  const hasAmazonLiveChat = useSelector(hasFeatureFlag("live-chat-amazon"));

  return hasAmazonLiveChat ? (
    <AmazonChatButton {...props} />
  ) : (
    <ChatButton8x8 {...props} />
  );
};
